import React from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const GrayIconWrapper = styled.span({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: 1,
});

export const GrayIcon = ({ testId }: { testId?: string }) => (
  <GrayIconWrapper data-testid={testId}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={token('color.background.accent.gray.subtlest')}
        fillRule="evenodd"
      />
    </svg>
  </GrayIconWrapper>
);
